module.exports = __webpack_public_path__ + "static/media/Logo BBB Book Club.6918e8db.jpeg";